export default __webpack_public_path__ + "static/media/bg-pattern-top-mobile.58eed600.svg";